<template>
<div class="max-dialog">
  <el-dialog
    title="取消订单提醒"
    width="890px"
    :append-to-body="true"
    :visible.sync="showDialog"
    center
  >
    <div>
      <span class="title">当前选中订单取消统计</span>
      <span class="title">子订单数：<span class="title-num">{{table.detail_count}}</span></span>
      <span class="title">主订单数：<span class="title-num">{{table.main_count}}</span></span>
    </div>
    <div class="day-main-body">

      <el-table
        :data="table.list"
        stripe
        style="width:100%"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
        ></el-table-column>
        <el-table-column
          label="编号"
          width="125"
        >
          <template slot-scope="scope">
           <span v-if="scope.row.serial_number">
            {{scope.row.serial_number.split('-').slice(3).join('-')}}
          </span>
          <span v-if="isZhifa && scope.row.courier_name">({{scope.row.courier_name}})</span>
          <span v-if="isFactory && scope.row.courier_name">({{scope.row.courier_name}})</span>
          </template>
        </el-table-column>

        <el-table-column
          property="main_number"
          label="主订单号"
          width="125"
        ></el-table-column>
        <el-table-column
          property="order_number"
          label="子订单号"
          width="125"
        ></el-table-column>
        <el-table-column
          property="ruigu_code"
          label="商品编码"
          width="100"
        ></el-table-column>
        <el-table-column
          property="name"
          label="商品名称"
        ></el-table-column>
        <el-table-column
          property="amount"
          label="数量"
          width="80"
        ></el-table-column>
        <el-table-column
          property="updated_at"
          label="取消时间"
        ></el-table-column>
      </el-table>
    </div>
    <div>
      <span class="tips"><i class="el-icon-warning"></i> 提示：上述订单已被客户取消，请务必检查备货情况</span>
    </div>
    <div>
      <span class="tip">如：1.请检查实物 ->2.重新打包 ->3.系统操作</span>
    </div>
    <div class="export">
      <div class="export-btn" @click="exportExcel">
        <div><i class="el-icon-download"></i> 导出Excel</div>
        <div>(取消订单信息明细)</div>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="cancelHandler">取消{{btnText}}</el-button>
      <el-button @click="confirmHandler" type="primary">确认{{btnText}}</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import { currentTime } from '@/utils/utils'
export default {
  props: {
    dialog: {
      type: Boolean
    },
    table: {
      type: Object,
      default: function () {
        return {
          detail_count: '',
          list: [],
          main_count: ''
        }
      }
    }
  },
  data () {
    return {
      showDialog: this.dialog,
      btnText: '',
      isZhifaOrFactory: localStorage.getItem('shop_type') === '2' || localStorage.getItem('shop_type') === '1',
      isZhifa: localStorage.getItem('shop_type') === '1',
      isFactory: localStorage.getItem('shop_type') === '2'
    }
  },
  watch: {
    dialog: {
      handler: function (val) {
        this.showDialog = val
      },
      immediate: true
    },
    showDialog: {
      handler: function (val) {
        if (!val) {
          this.$emit('cancel')
        }
      }
    }

  },
  methods: {
    cancelHandler () {
      this.showDialog = false
      this.$emit('cancel')
    },
    confirmHandler () {
      this.$emit('confirm')
    },
    exportExcel () {
      var xlsxParam = { raw: true } // 转换成excel时，使用原始的格式
      var wb = XLSX.utils.table_to_book(document.querySelector('.day-main-body'), xlsxParam)
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream;charset=utf-8' }),
          'orderCancel' + currentTime() + '.xlsx'
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout)
      }
      return wbout
      // let wb = XLSX.utils.table_to_book(
      //   document.querySelector('.day-main-body')
      // )
      // let wbout = XLSX.write(wb, {
      //   bookType: 'xlsx',
      //   bookSST: true,
      //   type: 'array'
      // })
      // try {
      //   let fileName = currentTime() + '.xlsx'
      //   FileSaver.saveAs(
      //     new Blob([wbout], {
      //       type: 'application/octet-stream'
      //     }),
      //     fileName
      //   )
      // } catch (e) {
      //   if (typeof console !== 'undefined') console.log(e, wbout)
      // }
      // return wbout
    }
  },
  created () {
    if (localStorage.getItem('shop_type') === '0') {
      this.btnText = '出库'
    }
    if (localStorage.getItem('shop_type') === '1') {
      this.btnText = '通知'
    }
    if (localStorage.getItem('shop_type') === '2') {
      this.btnText = '出库'
    }
  }
}
</script>
<style lang="scss">
.max-dialog {
  .orderNo {
    color:#409EFF;
  }
  .el-dialog__title {
    font-size: 14px !important;
    font-weight: bold;
  }
  .el-dialog__body {
    text-align: center;
  }
  .el-dialog {
    max-width: 800px;
    width:800px;
  }
}
</style>
<style lang="scss" scoped>
.tips{
  color:red;
  font-size: 14px;
  font-weight: bold;
}
.tip{
  font-size: 12px;
  display: inline-block;
  margin-top:5px;
  font-weight: bold;
}
.title{
  font-size: 14px;
  display: inline-block;
  padding-right: 10px;
  color: #000;
  margin-bottom: 10px;
  &-num{
    font-size: 18px;
    color: #ff6224;
  }
}
.export{
  padding-top: 10px;
  display: flex;
  justify-content: center;
  margin: auto;
  cursor: pointer;
  &-btn{
    width:110px;
    background: #E6E6E6;
    padding: 10px;
    text-align: center;
    div:nth-child(1){
      font-size: 14px;
      color: #333333;
      margin-bottom: 2px;
    }
    div:nth-child(2){
      font-size: 12px;
      color: #555555;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/OrderCancelDialog.vue